import React, { useState, useRef, useEffect } from 'react';
import { Card } from 'antd';
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import Swal from 'sweetalert2';
import LOGO from '../tormac.png'
import { BASE_URL } from "../App";
import CustomTextField from "./Numerictext";
import { Circles } from 'react-loader-spinner'

import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, Backdrop, CircularProgress, Avatar } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import QrReader from "react-camera-qr";


export default function Product_Registration() {
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);
    const [isScannerOpen, setScannerOpen] = useState(false);
    const [scannedData, setScannedData] = useState('');
    const [inputValue, setInputValue] = useState('');

    const location = useLocation();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const id = searchParams.get('id');
        if (id) {
            localStorage.setItem('PROREG_USER_ID', id);
        } else {
            localStorage.setItem('PROREG_USER_ID', 'User');
        }
    }, [location.search]);

    const handleSearch = () => {
        const LOGIN_ID = localStorage.getItem('PROREG_USER_ID');
        setOpen(true);
        const data = { type: 'validate_serialno', Serial_No: inputValue }
        axios.post(BASE_URL + '/ProductRegister', data)
            .then(response => {
                Swal.fire({
                    icon: "info",
                    text: response.data.message.message
                });
                if (response.data.message.status_code === '200') {
                    if (LOGIN_ID === 'USER' || (LOGIN_ID && LOGIN_ID.length < 6)) {
                        Swal.fire({
                            icon: "info",
                            text: "PRODUCT DETAILS REGISTERED !"
                        });
                        return false;
                    } else {
                        navigate('/Registration_details', {
                            state: {
                                Data: response.data.message,
                            }
                        });
                    }
                } else if (response.data.message.status_code === '201') {
                    navigate('/Registration_details', {
                        state: {
                            Data: response.data.message,
                        }
                    });
                }
            }).catch(error => {
                Swal.fire({
                    icon: "warning",
                    text: error.response.data.message
                });
            }).finally(() => {
                setOpen(false);
            });
    };

    const handleScan = () => {
        setScannerOpen(true);
    };

    function play() {
        var audio = new Audio(
            "https://media.geeksforgeeks.org/wp-content/uploads/20190531135120/beep.mp3"
        );
        audio.play();
    }

    const handleScanResult = (data) => {
        const LOGIN_ID = localStorage.getItem('PROREG_USER_ID');
        play();
        setScannedData(data);
        setInputValue(data);
        setScannerOpen(false);

        setOpen(true);
        const api_data = { type: 'validate_serialno', Serial_No: data }
        axios.post(BASE_URL + '/ProductRegister', api_data)
            .then(response => {
                Swal.fire({
                    icon: "info",
                    text: response.data.message.message
                });
                if (response.data.message.status_code === '200') {
                    if (LOGIN_ID === 'USER' || (LOGIN_ID && LOGIN_ID.length < 6)) {
                        Swal.fire({
                            icon: "info",
                            text: "PRODUCT DETAILS REGISTERED !"
                        });
                        return false;
                    } else {
                        navigate('/Registration_details', {
                            state: {
                                Data: response.data.message,
                            }
                        });
                    }
                } else if (response.data.message.status_code === '201') {
                    navigate('/Registration_details', {
                        state: {
                            Data: response.data.message,
                        }
                    });
                }
            }).catch(error => {
                Swal.fire({
                    icon: "warning",
                    text: error.response.data.message
                });
            }).finally(() => {
                setOpen(false);
            });
    };

    const handleScannerClose = () => {
        setScannerOpen(false);
    };

    // const containerStyle = {
    //     fontFamily: "Arial, sans-serif",
    //     padding: "20px",
    //     // backgroundColor: "#f9f9f9",
    //     // borderRadius: "10px",
    //     // boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    //     maxWidth: "12000px",
    //     margin: "20px auto",
    // };

    const headingStyle = {
        textAlign: "center",
        color: "#00a8a2",
        margin: "20px 0",
    };

    const paragraphStyle = {
        fontSize: "12px",
        color: "#555",
        lineHeight: "1.6",
        textAlign: "center",
    };

    return (
        <div className="m-4">
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
                {/* <CircularProgress color="inherit" /> */}
                <Circles height="80" width="80" color="rgba(255, 255, 255, 0.73)" />
            </Backdrop>
            <Card className="rounded" style={{ padding: '10px', boxShadow: '2px 4px 8px rgba(0, 168, 162, 1), inset 1px 2px 8px rgba(0, 168, 162, 1)', border: '1px solid #00a8a2' }}>
                <div>
                    <center>
                        <h3
                            style={{
                                background: 'linear-gradient(117deg, rgb(0, 168, 162) 20%, rgb(0, 168, 162) 80%)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                fontWeight: '1000',
                            }}
                        >
                            <i>Product Registration</i>
                        </h3>
                        <br />
                        {/* <Avatar
                            alt="LOGO"
                            src={LOGO}
                            sx={{ width: 110, height: 110 }}
                        /> */}
                        <img
                            src={LOGO}
                            alt="LOGO"
                            style={{
                                width: '100%',
                                maxWidth: '300px',
                                height: 'auto',
                                display: 'block',
                                margin: '0 auto'
                            }}
                        />

                    </center>
                </div>
                <br />
                <div>
                    <center>
                        <b>
                            <div>
                                <center>
                                    <strong>Repair or Replacement Coverage:</strong> Ensures your product is covered under warranty.<br />
                                    <strong>Stay Informed:</strong> Keeps you updated on safety recalls and notifications.<br />
                                    <strong>Exclusive Perks:</strong> Access offers, discounts, and upgrades.<br />
                                    <div>
                                        <h3 style={headingStyle}>Why Register Products?</h3>
                                    </div>
                                    <p style={paragraphStyle}>
                                        Registering your product protects your purchase, provides peace of mind with warranty and safety updates, and offers additional perks like special offers or loyalty rewards.<br /> It's a simple way to ensure better support and
                                        a safer, more rewarding ownership experience.
                                    </p>
                                </center>
                            </div>
                            <em><a href="https://en.tormacpumps.com/" target='_blank' style={{ color: '#00a8a2', }}><u><b>TORMAC PUMPS </b></u></a></em> values your privacy and will never share your information with other companies.
                        </b>
                    </center>
                </div>
                <br />
                <div className='row'>
                    <div className='col-md-6'>
                        <CustomTextField
                            className='mt-4'
                            label="Enter Serial Number"
                            name="Enter Serial Number"
                            size="small"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                        />
                        {/* <input className="form-control" name="" id="" type="text" value={inputValue} onChange={(e) => setInputValue(e.target.value)} /> */}
                    </div>
                    <div className='col-md-6'>
                        {/* <div className='row'>
                            <div className='col'> */}
                                &emsp;
                                <Button fullWidth variant="contained" onClick={handleSearch} endIcon={<SearchIcon />} style={{ background: 'linear-gradient(117deg, rgb(0, 168, 162) 20%, rgb(0 213 200) 80%)' }}><b>Search</b></Button>
                            {/* </div>
                            <div className='col'>
                                &emsp;
                                <Button fullWidth variant="contained" onClick={handleScan} endIcon={<QrCodeScannerIcon />} style={{ background: 'linear-gradient(117deg, rgb(0 213 200) 20%, rgb(0, 168, 162) 80%)' }}><b>Scan</b></Button>
                        */}
                            {/* </div>
                        </div>  */}
                    </div>
                </div>
                <p className="mt-2 text-muted text-small" style={{ float: 'right', fontSize: '1rem', textAlign: 'right', marginRight: '-10px' }}>
                    Powered By &nbsp;
                    <span style={{ cursor: 'pointer' }}>
                        <a href='https://grsystems.co.in/' target='_blank'>
                            <i className="animated-text">
                                <u style={{ color: '#004aff' }}>GR Systems</u>
                            </i>
                        </a>
                    </span>
                </p>
            </Card>
            <QRScannerModal open={isScannerOpen} onClose={handleScannerClose} onScan={handleScanResult} />
        </div>
    );
}


const QRScannerModal = ({ open, onClose, onScan }) => {
    const videoRef = useRef(null);
    const [mediaStream, setMediaStream] = useState(null);

    const setCameraSettings = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: 'environment', // Change to 'user' for front camera
                    width: 1280,
                    height: 720,
                    // Here you can attempt to set zoom and focus
                    advanced: [
                        {
                            zoom: 1.7,
                            focusMode: 'manual'
                        }
                    ]
                }
            });

            if (videoRef.current) {
                videoRef.current.srcObject = stream;
            }
            setMediaStream(stream);
        } catch (err) {
            console.error('Error accessing media devices.', err);
        }
    };

    const handleScan = (data) => {
        if (data) {
            onScan(data);
            handleDialogClose(); // Close the dialog after scanning
        }
    };

    const handleDialogClose = () => {
        if (mediaStream) {
            mediaStream.getTracks().forEach(track => track.stop());
        }
        setMediaStream(null); // Clear the media stream
        onClose();
    };

    useEffect(() => {
        if (open) {
            setCameraSettings(); // Start the camera when the modal opens
        } else {
            handleDialogClose(); // Ensure tracks are stopped when the modal closes
        }
    }, [open]);

    return (
        <Dialog open={open} onClose={handleDialogClose} fullWidth>
            <DialogTitle><u><b>QR Code Scanner</b></u></DialogTitle>
            <DialogContent>
                <video
                    ref={videoRef}
                    style={{ width: "100%", height: "300px", objectFit: 'cover' }}
                    autoPlay
                />
                <QrReader
                    delay={800}
                    onError={console.error}
                    onScan={handleScan}
                    style={{ display: 'none' }} // Hide the default scanner
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleDialogClose} variant="outlined">Close</Button>
            </DialogActions>
        </Dialog>
    );
};
